import { v4 as uuidv4 } from 'uuid';

export function FormInputCheckbox(props = {}, childrenComponents = []) {
	return {
		componentName: 'FormInputCheckbox',
		componentId: uuidv4(),
		props: Object.assign(
			{
				pointer: '',
				label: '',
			},
			props,
		),
		childrenComponents,
	};
}
